import { queryOptions } from "@tanstack/react-query";
import { getCustomWeekRange, myAxios } from "../utils/common";
import {
  IAssignedModule,
  IItemCompletionResult,
  IMlPart,
  IPractice,
  TTask,
} from "../types/generalTypes";
// ZOOM DEVRE DIŞI
// import { IZoomConnectInfos } from "../modulez/zoom/zoomTypes";
import { IMccUnit, ITodaysUnit } from "../types/unitTypes";
import { format } from "date-fns";
import { IProjectUserData } from "../modulez/project/sandpackProject/statics";
import { CurriculumResponse } from "../modulez/curriculum/types";
import { IHomeCurrent } from "../types/homeTypes";

export const fetchPartsByMlId = async (ml_id: number): Promise<IMlPart[]> =>
  myAxios.get(`/unit-ml-part/byUnitMlId/${ml_id}`).then((r) => r.data);

export const qoMlParts = ({
  ml_id,
  add_outro = true,
}: {
  ml_id: number;
  add_outro?: boolean;
}) =>
  queryOptions({
    queryFn: () => fetchPartsByMlId(ml_id),
    queryKey: ["mlPart", { ml_id }],
    enabled: !!ml_id && ml_id > 0,
    select: (res: IMlPart[]) => {
      // biraz hacky, sona değerlendirme live bölümü ekle
      // neden yapıyorum? db ile loosely iletişimi olsun diye.

      if (res.length > 0 && !res.find((p) => p.id === -1)) {
        const resWithType: IMlPart[] = res.map((p) => ({
          ...p,
          type: p.video_url && p.video_url?.length > 0 ? "VIDEO" : "ZOOM",
        }));
        if (add_outro) {
          resWithType.push({
            part_title: "Değerlendirme",
            id: -1,
            type: "ZOOM",
          });
        }
        return resWithType;
      } else {
        return res;
      }
    },
  });

/*

*/

export const fetchPracticesByPartId = async (
  part_id: number
): Promise<IPractice[]> =>
  myAxios
    .get(`/unit-ml-part-practice/byUnitMlPartId/${part_id}`)
    .then((r) => r.data);

export const qoPartPractices = ({ part_id }: { part_id: number }) =>
  queryOptions({
    queryFn: () => fetchPracticesByPartId(part_id),
    queryKey: ["partPractices", { part_id }],
    enabled: !!part_id,
  });

/*

*/

export const fetchPracticesById = async (
  practiceId: number
): Promise<IPractice> =>
  myAxios.get(`/unit-ml-part-practice/byId/${practiceId}`).then((r) => r.data);

export const qoGetSinglePractice = ({ practiceId }: { practiceId?: number }) =>
  queryOptions({
    queryFn: () => fetchPracticesById(practiceId!),
    queryKey: ["singlePractice", { practiceId }],
    enabled: !!practiceId,
  });

/*

*/

export const fetchPracticesHistoryByPartId = async (
  part_id: number,
  user_id: number
): Promise<Record<string, number | null>> =>
  myAxios
    .post("/unit-ml-part/findMaxAndAvgGradesOfStudent", {
      unit_ml_part_id: part_id,
      user_id,
      is_avg: false,
    })
    .then((r) => r.data?.["max-scores"]);

export const qoPartPracticesHistory = ({
  part_id,
  user_id,
}: {
  part_id: number;
  user_id: number;
}) =>
  queryOptions({
    queryFn: () => fetchPracticesHistoryByPartId(part_id, user_id),
    queryKey: ["partPracticesHistory", { part_id }],
    enabled: !!part_id && !!user_id,
  });

/*

*/

export const fetchContentByDate = async (
  cohort_ids: number[],
  user_id?: number
): Promise<IAssignedModule[]> => {
  const thisWeek = getCustomWeekRange();
  return myAxios
    .post("/module_cohort_content/byDate", {
      cohort_ids,
      user_id,
      ...thisWeek,
    })
    .then((r) => r.data);
};

export const qoCurrentWeekContents = ({
  cohort_ids,
  user_id,
}: {
  cohort_ids: number[];
  user_id?: number;
}) =>
  queryOptions({
    queryFn: () => fetchContentByDate(cohort_ids, user_id),
    queryKey: ["weekContents", { cohort_ids, user_id }],
    enabled: cohort_ids && cohort_ids.length > 0,
  });

/*  
  
*/
interface IFetchAllWeekContents {
  cohort_ids: number[];
  strict_match?: boolean;
  user_id?: number;
}
export const fetchAllAssigneds = async (
  data: IFetchAllWeekContents
): Promise<IAssignedModule[]> =>
  myAxios.post("/module_cohort_content/byCohortId", data).then((r) => r.data);

export const qoAllWeekContents = (data: IFetchAllWeekContents) =>
  queryOptions({
    queryFn: () => fetchAllAssigneds(data),
    queryKey: ["allWeekContents", data],
    enabled: data.cohort_ids && data.cohort_ids.length > 0,
  });

/*  
  
*/
export const fetchTodaysUnit = async (
  cohort_id: number,
  date: string
): Promise<ITodaysUnit> =>
  myAxios
    .post("/unit/today", {
      cohort_id,
      date,
    })
    .then((r) => r.data);

export const qoTodaysUnit = ({
  cohort_id,
  date,
}: {
  cohort_id?: number;
  date?: string;
}) => {
  const today = format(new Date(), "yyyy-MM-dd");
  return queryOptions({
    queryFn: () => fetchTodaysUnit(cohort_id!, date || today),
    queryKey: ["todaysUnit", { cohort_id, date }],
    enabled: !!cohort_id,
    refetchOnMount: "always",
    refetchOnWindowFocus: "always",
  });
};
/*
  
*/
// ZOOM DEVRE DIŞI — Canlı ders özelliği kullanılmıyor.
// interface IGenerateStudentSignature {
//   userName: string;
//   userEmail: string;
//   meetingToken: string;
// }
// export const generateStudentSignatureFn = async (
//   data: IGenerateStudentSignature
// ): Promise<IZoomConnectInfos> =>
//   myAxios.post("/zoom/generateStudentSignature", data).then((r) => r.data);
//
// export const qoGenerateStudentSignature = (
//   data: IGenerateStudentSignature,
//   isStudent: boolean
// ) =>
//   queryOptions({
//     queryFn: () => generateStudentSignatureFn(data),
//     queryKey: ["studentSignature", { email: data.userEmail }],
//     enabled: !!data.meetingToken && isStudent,
//   });

/*
  
*/

interface IGetMccUnitDetails {
  cohort_id: number;
  unit_id: number;
  user_id: number;
  add_intro?: boolean;
}
export const getMccUnitDetails = async (
  data: IGetMccUnitDetails
): Promise<IMccUnit[]> =>
  myAxios.post("/unit/unitDetails", data).then((r) => r.data);

export const qoGetMccUnitDetails = (data: IGetMccUnitDetails) => {
  const { cohort_id, unit_id, user_id, add_intro = true } = data;

  return queryOptions({
    queryFn: () => getMccUnitDetails(data),
    queryKey: ["unitDetails", data],
    enabled: !!unit_id && !!cohort_id && !!user_id,
    select: (res) => {
      const cloned = structuredClone(res);

      if (
        cloned.length > 0 &&
        !cloned[0].unit_mls.some((ml) => ml.ml_id === -1) &&
        add_intro
      ) {
        cloned[0].unit_mls.unshift({
          ml_id: -1,
          ml_title: "Giriş",
        });
      }

      return cloned;
    },
  });
};

/*

*/

export interface IItemCompletionQuery {
  content_id: number;
  user_id: number;
  type: TTask;
}
export const fetchUserItemCompletionFn = async (
  data: IItemCompletionQuery
): Promise<IItemCompletionResult> =>
  myAxios.post("/cache", data).then((r) => r.data);

export const qoUserItemCompletion = (data: IItemCompletionQuery) => {
  const { content_id, user_id, type } = data;
  return queryOptions({
    queryFn: () => fetchUserItemCompletionFn(data),
    queryKey: ["userItemScore", { content_id, type }],
    enabled: !!content_id && !!user_id,
  });
};
/*

*/

export const fetchProjectDetailsWithUserData = async (data: {
  project_id: number;
  user_id: number;
}): Promise<IProjectUserData> =>
  myAxios.post("/projectLog/details", data).then((r) => r.data);

export const qoGetProjectWithUserData = (data: {
  project_id: number;
  user_id: number;
}) =>
  queryOptions({
    queryFn: () => fetchProjectDetailsWithUserData(data),
    queryKey: ["projectWithUserData", { projectId: data.project_id }],
    // Önbellekten açılırsa editör eski user_files ile başlar ve otomatik kayıt onu geri yazar
    gcTime: 0,
  });

export interface IProjectSolution {
  question_number: number;
  title: string;
  solution_code: string;
  language: string;
}

export interface IProjectSolutionsResponse {
  project_title: string | null;
  solutions: IProjectSolution[];
}

export const fetchProjectSolutions = async (
  projectId: number
): Promise<IProjectSolutionsResponse> =>
  myAxios.get(`/projectLog/solutions/${projectId}`).then((r) => r.data);

export const qoProjectSolutions = (projectId: number) =>
  queryOptions({
    queryFn: () => fetchProjectSolutions(projectId),
    queryKey: ["projectSolutions", { projectId }],
    enabled: !!projectId && projectId > 0,
  });

/* 
  

  
*/
export interface IModuleCompletionData {
  user_id?: number;
  module_cohort_id: number;
}

interface IModuleCompletion {
  avg_all: number;
  avg_unit: number;
  avg_project: number;
}

export const fetchModuleCompletion = async (
  data: IModuleCompletionData
): Promise<IModuleCompletion[]> =>
  myAxios.post("/cache/module", data).then((r) => r.data);

export const qoFetchModuleCompletion = (data: IModuleCompletionData) =>
  queryOptions({
    queryFn: () => fetchModuleCompletion(data),
    queryKey: ["userModuleScore", data],
    enabled: !!data.user_id,
  });

// ── Live Lesson Records ──
export interface ILiveLessonRecord {
  id: number;
  title: string;
  program_type: string;
  vimeo_id: string | null;
  github_url: string | null;
  lesson_date: string;
  week_number: number;
  display_order: number;
  related_module_ids: number[];
}

export const fetchLiveLessonRecords = async (
  programType: string
): Promise<ILiveLessonRecord[]> =>
  myAxios
    .get<ILiveLessonRecord[]>(
      `/live-lesson-records?program_type=${programType}`
    )
    .then((r) => r.data);

export const qoLiveLessonRecords = ({
  programType,
}: {
  programType: string;
}) =>
  queryOptions({
    queryFn: () => fetchLiveLessonRecords(programType),
    queryKey: ["liveLessonRecords", { programType }],
    enabled: !!programType,
    staleTime: 5 * 60 * 1000,
  });

// ── Live Classes ──
export interface ILiveClassSchedule {
  id: number;
  label: string;
  day_of_week: number;
  hour: number;
  minute: number;
  duration_minutes: number;
  pre_active_minutes: number;
  zoom_link: string;
  cohort_ids: number[];
  education_types: string[] | null;
  excluded_dates: string[] | null;
}

export const qoLiveClasses = ({ cohort_id }: { cohort_id: number }) =>
  queryOptions({
    queryFn: () =>
      myAxios
        .get<ILiveClassSchedule[]>(`/live-classes?cohort_id=${cohort_id}`)
        .then((r) => r.data),
    queryKey: ["liveClasses", { cohort_id }],
    enabled: !!cohort_id,
    staleTime: 5 * 60 * 1000,
  });

// ── Lesson Requests ──
export interface ILessonRequest {
  id: number;
  request_type: string;
  content: string;
  cohort_id: number;
  user_id: number;
  reference_label?: string;
  module_label?: string;
  status: string;
  created_at: string;
}

export const qoLessonRequests = () =>
  queryOptions({
    queryFn: () =>
      myAxios.get<ILessonRequest[]>("/lesson-requests").then((r) => r.data),
    queryKey: ["lessonRequests"],
  });

// ── Gamification ──
export interface IGamificationStats {
  totalXp: number;
  currentStreak: number;
  longestStreak: number;
  freezeCount: number;
  freezeInUse: number;
  level: number;
  levelProgress: number;
  xpToNextLevel: number;
}

export const qoGamificationStats = () =>
  queryOptions({
    queryFn: () =>
      myAxios.get<IGamificationStats>("/gamification/stats").then((r) => r.data),
    queryKey: ["gamificationStats"],
    staleTime: 10 * 1000,
  });

// ── Student Curriculum (Müfredat Yolculuğum) ──

export const fetchStudentCurriculum = async (): Promise<CurriculumResponse> =>
  myAxios.get("/student/curriculum").then((r) => r.data);

export const qoStudentCurriculum = () =>
  queryOptions({
    queryFn: fetchStudentCurriculum,
    queryKey: ["studentCurriculum"],
    staleTime: 5 * 60_000,
  });

// ── Home Current (Kaldığın Yer / Devam Et) ──

export const fetchHomeCurrent = async (): Promise<IHomeCurrent> =>
  myAxios.get("/home/current").then((r) => r.data);

export const qoHomeCurrent = () =>
  queryOptions({
    queryFn: fetchHomeCurrent,
    queryKey: ["homeCurrent"],
    staleTime: 30 * 1000,
  });
